import PropTypes from 'prop-types';
import React from 'react';
import UIkit from 'uikit';
import produce from 'immer';
import FormWizard from '../components/FormWizard';
import Input from '../components/Input';

export default class Form extends FormWizard {

  constructor(props) {
    super(props);
    this.state = {
      errors: [],
      object: props.object
    }
  }

  render() {
    return (
      <form onSubmit={ this.handleSubmit }>
        { this.renderInputs() }
        <input type="submit" name="commit" value="Submit" className="btn uk-button uk-button-secondary " disabled={this.state.isLoading ? "disabled" : ""} />
      </form>
    )
  }

  renderInputs() {
    return(
      <React.Fragment>
        { this.props.formFields.map((field, index) => {
          return(
            <Input { ...field } object={this.state.object} error={this.state.errors[field.name]} handleReactSelectChange={this.handleReactSelectChange} handleChange={this.handleChange } key={index}/>
          )
        })}
      </React.Fragment>
    )
  }

  handleFormSuccess = (response) => {
    window.location.href = this.props.successRedirect
  }

  handleFormFailure = (error) => {

    console.log(error, "form failure");
    this.setState({ errors: {...error.response.data } })
    console.log(error.response.data, "form failure");
  }
}
